// import Service from '@/service/index.js';
import synthesizeFormMixins from '../mixins/synthesize-form.js';
export default {
  mixins: [synthesizeFormMixins],
  props: ['projectInfo'],
  data() {
    return {
      bidGeneralSituation: 5, // 建筑物信息
      massifs: [
        {
          massifName: '',
          area: null,
          certificateNo: '',
          // startTime: '',
          // endTime: '', // 出租期限
          address: '', // 坐落位置
          serialNumber: '', // 房产证编号
          bidStructure: '', // 标的结构
          originalPurpose: '', // 建设用途
          attachmentRemark: ''
        }
      ],
      rules: {
        massifName: [
          { required: true, message: '请输入建筑名称', trigger: 'blur' }
        ],
        address: [
          { required: true, message: '请输入坐落位置', trigger: 'blur' }
        ],
        serialNumber: [
          { required: true, message: '请输入房产证编号', trigger: 'blur' }
        ],
        bidStructure: [
          { required: true, message: '请输入标的结构', trigger: 'blur' }
        ],
        attachmentRemark: [
          { required: true, message: '请输入装修及附属设施情况', trigger: 'blur' }
        ],
        originalPurpose: [
          { required: true, message: '请输入建设用途', trigger: 'blur' }
        ]
      }
    };
  },
  methods: {
    clear(){
      if( this.projectInfo.projectType === 6) return false;
      this.massifs = [
        {
          massifName: '',
          area: null,
          certificateNo: '',
          endTime: '', // 出租期限
          address: '', // 坐落位置
          serialNumber: '', // 房产证编号
          bidStructure: '', // 标的结构
          originalPurpose: '', // 建设用途
          attachmentRemark: ''
        }
      ];
      this.totalForm = {
        sumArea: null
      };
      // 清空红色必填标示
      if(this.$refs['houseForm']) {
        this.$refs['houseForm'].resetFields();
      }
    },
    addLand () {
      this.massifs.push({
        massifName: '',
        area: null,
        certificateNo: '',
        endTime: '', // 出租期限
        address: '', // 坐落位置
        serialNumber: '', // 房产证编号
        bidStructure: '', // 标的结构
        originalPurpose: '', // 建设用途
        attachmentRemark: ''
      });
    },
    deleteLand (index) {
      this.massifs.splice(index, 1);
    }
  }
};
